// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._0Gy3yo7Qx-zTGimwRO7kqg\\=\\={padding-bottom:5.6rem;padding-top:2.4rem}.tIsac78OUVcq1iKtNa-QHg\\=\\={-webkit-box-orient:vertical;-webkit-line-clamp:3;display:-webkit-box;overflow:hidden}@media (min-width:992px){._0Gy3yo7Qx-zTGimwRO7kqg\\=\\={padding-top:3.2rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "_0Gy3yo7Qx-zTGimwRO7kqg==",
	"clampText": "tIsac78OUVcq1iKtNa-QHg=="
};
module.exports = ___CSS_LOADER_EXPORT___;
